import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store/index'
import { ElMessage } from "element-plus";

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home/index.vue'),
  },
  {
    path: '/publishers',
    name: 'publishers',
    component: () => import('@/views/Publishers/index.vue'),
  },
  {
    path: '/advertisers',
    name: 'advertisers',
    component: () => import('@/views/Advertisers/index.vue'),
  },
  {
    path: '/about_us',
    name: 'about_us',
    component: () => import('@/views/About_us/index.vue'),
  },
  {
    path: '/contact_us',
    name: 'contact_us',
    component: () => import('@/views/Contact_us/index.vue'),
  },
  {
    path: '/privacy_policy',
    name: 'privacy_policy',
    component: () => import('@/views/privacy_policy.vue'),
  },
  {
    path: '/terms_of_service',
    name: 'terms_of_service',
    component: () => import('@/views/terms_of_service.vue'),
  },
  // 404 页面
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: () => import('@/views/404.vue')
  },
  {
    // 路由重定向
    path: '/',
    redirect: {
      path: '/',
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 每次路由跳转之后 新页面加载在x轴和y轴的初始位置
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
    };
  },
})

// 全局前置守卫
router.beforeEach((to, from, next) => {

  next();

});

export default router

